/* global google */
import React, { Component } from 'react';
import firebase from 'firebase';
import 'moment/locale/es';
import './style.css';
import MapaRuta from './mapaRuta';
import ColorBar from './ColorBar';
import { Pulse } from 'react-preloading-component';
import moment from 'moment';
import DetalleRuta from './detalleRuta';
import AllRoutes from '../../img/reload.svg';

class EstatusRutas extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isStarting: true,
            viajesActivos: [],
            rutas: [],
            conductorV: [],
            clientes: [],
            orderByRutes: [],
            programacion: [],
            vehiculos: [],
            rutaSeleccionada: {},
            travelFind: '-1',
            velocity: {},
            isLoading: true,
            agentes: []
        }

    }

    componentWillMount = () => {
        this.getRutas();
    }

    componentWillUnmount = () => {
        let { agentes } = this.state;
        agentes.forEach(element => {
            firebase.database().ref('ProgramacionDia/' + element.key + '/estado').off();
            firebase.database().ref('ProgramacionDia/' + element.key + '/checkpoints').off();
            firebase.database().ref('EmpleadosGPS/' + element.conductor).off();
            firebase.database().ref('DatosViajes/' + element.key).off()
        });
    }

    getRutas = () => {
        firebase.database().ref('Rutas').once('value').then(snap => {
            let rutas = [];
            let clientes = [];
            let vehiculos = [];
            let tiposViaje = [];
            let programacion = [];
            snap.forEach(element => {
                let datos = element.val();
                datos.key = element.key;
                rutas.push(datos);
            });
            firebase.database().ref('Clientes').once('value').then(snapCli => {
                snapCli.forEach(element => {
                    let datos = element.val();
                    datos.key = element.key;
                    clientes.push(datos);
                });
                firebase.database().ref('TiposViajes').once('value').then(snapVia => {
                    snapVia.forEach(element => {
                        let datos = element.val();
                        datos.key = element.key;
                        tiposViaje.push(datos);
                    });
                    firebase.database().ref('Programacion').once('value').then(snapProgra => {
                        snapProgra.forEach(element => {
                            let datos = element.val();
                            datos.key = element.key;
                            programacion.push(datos);
                        });
                        firebase.database().ref('Vehiculos').once('value').then(snapVehi => {
                            snapVehi.forEach(element => {
                                let datos = element.val();
                                if (datos.placa !== undefined) {
                                    datos.key = element.key;
                                    vehiculos.push(datos);
                                }
                            });
                            this.setState({ rutas, clientes, tiposViaje, programacion, vehiculos });
                            this.getProgramacionDia(true);
                        })
                    })
                })
            })
        })
    }

    addNewData = (nuevo) => {
        let { agentes } = this.state;
        let data = nuevo.ref_.path.pieces_[1];
        firebase.database().ref('ProgramacionDia/' + data ).once('value').then(snap => {
            let agentes2 = [];
            agentes.forEach(element => {
                if(element.key === data){
                    let obje = snap.val();
                    let inicio = obje.horaInicio.split(':');
                    let destino = obje.horaLlegada.split(':');
                    obje.horaInicio = moment().hour(Number(inicio[0])).minute(Number(inicio[1])).format('HH:mm');
                    obje.horaLlegada = moment().hour(Number(destino[0])).minute(Number(destino[1])).format('HH:mm');
                    obje.key = element.key;
                    obje.estado = obje.estado === 'sinced' ? 'Abordando' : obje.estado;
                    agentes2.push(obje)
                }else{
                    agentes2.push(element)
                }
                
            });
            this.setState({ agentes: agentes2 })
            this.filterRutas( agentes2 )
        })
    }

    listenForNewData =  (element) => {
        firebase.database().ref('ProgramacionDia/' + element.key + '/estado').off();
        firebase.database().ref('ProgramacionDia/' + element.key + '/estado').on('value', snap => {
            let valor = snap.val()
            if (valor.estado === 'Finalizado') {
                firebase.database().ref('ProgramacionDia/' + valor.key).off();
                firebase.database().ref('EmpleadosGPS/' + valor.conductor).off();
            }
            this.addNewData(snap);
        })
        firebase.database().ref('ProgramacionDia/' + element.key + '/checkpoints').off();
        firebase.database().ref('ProgramacionDia/' + element.key + '/checkpoints').on('value', snap => {
            this.addNewData(snap);
        })
    }

    getProgramacionDia = (isStarting) => {
        let date = new Date();
        let mes = date.getMonth() + 1;
        mes = parseInt(mes) < 10 ? '0' + mes : mes;
        let fechaB = new Date(date.getFullYear() + '/' + mes + '/' + date.getDate());
        let dateFormat = fechaB.toDateString() + ' 00:00:00 GMT-0600 (hora estándar central)';
        firebase.database().ref('ProgramacionDia').orderByChild('fecha').equalTo(String(dateFormat)).once('value').then(snap => {
            let programacionDia = [];
            snap.forEach(element => {
                if (isStarting === true) {
                    this.listenForNewData(element);   
                }
                let obje = element.val();
                let inicio = obje.horaInicio.split(':');
                let destino = obje.horaLlegada.split(':');
                obje.horaInicio = moment().hour(Number(inicio[0])).minute(Number(inicio[1])).format('HH:mm');
                obje.horaLlegada = moment().hour(Number(destino[0])).minute(Number(destino[1])).format('HH:mm');
                obje.key = element.key;
                obje.estado = obje.estado === 'sinced' ? 'Abordando' : obje.estado;
                programacionDia.push(obje);
            });
            this.setState({ agentes: programacionDia })
            this.filterRutas(programacionDia)
        });
    }

    filterRutas(programacionDia) {
        let r = programacionDia;
        r.sort((a, b) => {
            let horaA = a.horaInicio;
            let horaB = b.horaInicio;
            let splitA = horaA.split(':');
            let splitB = horaB.split(':');
            let horaInicioA = moment().hour(Number(splitA[0])).minute(Number(splitA[1])).format('HHmm');
            let horaInicioB = moment().hour(Number(splitB[0])).minute(Number(splitB[1])).format('HHmm');
            return parseInt(horaInicioA) - parseInt(horaInicioB);
        });
        let viajes = []
        r.map(f => {
            if (f.conductor !== "" && f.vehiculo !== "" && f.estado !== 'Finalizado' && f.estado !== 'Inactivo' && f.estado !== 'Cancelado') {
                viajes.push(f)
            }
        });
        this.followPosition(viajes);
    }

    followPosition = async (viajes) => {
        let viajesActivos = [];

        for (const element of viajes) {
            if(!element.vehiculo)
                element.vehiculo='';
                
            if(!element.conductor)
                element.conductor='';

            let valor = await this.getTravelInfoActive(element);
            
            if(valor)
                viajesActivos.push(valor);
        }


        let viajesA    = [];
        let conductorV = [];
        viajesActivos.forEach(element => {
            viajesA.push(element);
            conductorV.push({ conductor: element.conductor, key: element.key });
        });

        this.setState({ viajesActivos: viajesA, conductorV })
        this.splitTravels(viajesA);

    }

    getTravelInfoActive = (element) => {
        return new Promise((resolve, reject) => {
            firebase.database().ref('ProgramacionDia/' + element.key).off();
            // firebase.database().ref('ProgramacionDia/' + element.key).on('value', snap => {
                // let viaje = snap.val()
                firebase.database().ref('EmpleadosGPS/' + element.conductor).off();
                firebase.database().ref('EmpleadosGPS/' + element.conductor).on('value', snapC => {
                    let { conductorV, rutas, programacion, vehiculos, viajesActivos } = this.state;
                    let valor = snapC.val();
                    let rutaFind = rutas.find(x => element.ruta === x.key);
                    let progra = programacion.find(x => element.programacion === x.key);
                    let vehiculo = vehiculos.find(x => element.vehiculo === x.key)


                    if (rutaFind  && vehiculo) {
                        resolve({ rutaViaje: { ...rutaFind }, conductor: { ...valor }, prograDia: { ...element }, programacion: { ...progra }, vehiculo: { ...vehiculo }, key: element.key })
                        if (conductorV.length !== 0) {
                            let objIndex = conductorV.findIndex((obj => obj.key == element.key));
                            if (conductorV[objIndex] !== undefined) {
                                conductorV[objIndex].conductor.latitud = valor.latitud;
                                conductorV[objIndex].conductor.longitud = valor.longitud;
                                this.setState({ conductorV })
                            }
                        }
                    }else{
                     resolve();   // console.log('element :', element);
                    }
                })
            // })
        })
    }

    splitTravels = (viajesA) => {
        let { tiposViaje } = this.state;
        
        let orderByRutes = [];
        tiposViaje.forEach(element => {
            let dato = {
                tipo: element.nombre,
                rutas: viajesA.filter(ruta => '' + ruta.prograDia.rutaF.tipoViaje === element.key)
            }
            orderByRutes.push(dato)
        });
        this.setState({ orderByRutes })
    }

    filterRoute = (rutaSeleccionada, viajesActivos) => {
        let { velocity } = this.state;
        let travelFind = viajesActivos.findIndex(x => rutaSeleccionada.key === x.key);
        let viaje = this.state.viajesActivos[travelFind].key;
        velocity !== null ? firebase.database().ref('DatosViajes/' + viaje).off() : '';
        firebase.database().ref('DatosViajes/' + viaje).on('value', snap => {
            let velocity = snap.val()
            if (velocity !== null) {
                velocity.key = snap.key;
            }
            this.setState({ velocity })
        })
        this.setState({ travelFind })
    }

    lookAll = () => {
        let { velocity, travelFind } = this.state;
        if (travelFind !== '-1') {
            velocity !== null ? firebase.database().ref('DatosViajes/' + travelFind.key).off() : '';
        }
        this.setState({ rutaSeleccionada: {}, travelFind: '-1' });
    }

    render() {
        let { viajesActivos, conductorV, clientes, orderByRutes, travelFind, velocity, isStarting } = this.state;
        return (
            <div style={{ marginRight: 15, marginLeft: 15 }}>
                <div className="row">
                    <div style={{ height: '450px' }} className="col-md-3 col-sm-12 scrollItem">
                        {orderByRutes.length === 0 && <Pulse />}
                        {orderByRutes.map((snapRutas, i) => {
                            let rutas = snapRutas.rutas.length > 0 ? snapRutas.rutas : [];
                            return (
                                <div key={i}>
                                    <p className="rutasText">{snapRutas.tipo}</p>
                                    <br />
                                    {
                                        rutas.map((snapDetalle, index) => (
                                            <div onClick={() => this.filterRoute(snapDetalle, viajesActivos)} className="d-flex flex-row btnStyle" key={index}>
                                                <ColorBar color={snapDetalle.prograDia.rutaF.coloRuta} />
                                                <div style={{ height: 25, margin: 5 }} className='d-flex justify-content-center align-items-center truncate'>
                                                    <p className="rutasText">{snapDetalle.prograDia.programacionF.vuelo}</p>
                                                </div>
                                            </div>
                                        ))
                                    }
                                    {rutas.length === 0 ? <p className="rutasTextBlack">*Sin rutas disponibles*</p> : ''}
                                    <br />
                                </div>
                            )
                        })}
                    </div>
                    <div className="col-md-9 col-sm-12">
                        <MapaRuta
                            googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyATad9mdS85bZPesVOnJpSP3BSwVAg60aY&v=3.exp&libraries=geometry,drawing,places"
                            loadingElement={<div style={{ height: '600px', }} />}
                            containerElement={<div />}
                            mapElement={<div style={{ height: '450px', width: '100%' }} />}
                            viajesActivos={viajesActivos}
                            conductorV={conductorV}
                            rutaSeleccionada={travelFind !== '-1' ? viajesActivos[travelFind] : {}}
                        />
                        <img onClick={this.lookAll} className="absoluteImage" src={AllRoutes} />
                    </div>
                </div>
                <DetalleRuta
                    velocity={velocity}
                    clientes={clientes}
                    rutaSeleccionada={travelFind !== '-1' ? viajesActivos[travelFind] : {}}
                />
            </div>
        )
    }
}
export default EstatusRutas;


// WEBPACK FOOTER //
// ./src/Components/Rutas/EstatusRutas.js